/**
 * The persisted outlet cookie — mirrors this directory's nav.ts cookie codec
 * (URL-encoding discipline, tolerant decode) for a single outlet code instead
 * of a space-separated key list.
 *
 * WRITTEN by SupplyOutletCookieSync (a mount effect — a Server Component may
 * not set cookies during render, and doing it in a server action would
 * re-render the whole route). READ by the SERVER, in ./outlet-server.ts, to
 * resolve the outlet for any /supply request that arrives without `?outlet=`
 * — a route-level loading.tsx has no session and cannot resolve one itself,
 * and neither can the outlet-agnostic HQ desk pages that still render rail
 * links to outlet-scoped surfaces.
 */
export const SUPPLY_OUTLET_COOKIE = "fb_supply_outlet";
export const SUPPLY_OUTLET_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

export function encodeOutletCookie(outletCode: string): string {
  return encodeURIComponent(outletCode);
}

// No decodeOutletCookie here, deliberately. The single reader is
// outletFromCookieValue in ./outlet-server.ts, which must do more than decode:
// it validates the result against the outlets the session actually reaches,
// and treats an undecodable value as "no outlet" rather than falling back to
// the raw, still-encoded string. A bare decode helper exported from here would
// invite a second reader with looser failure semantics than the one that
// gates access — exactly the kind of quiet divergence this cookie cannot
// afford now that the SERVER trusts it to choose an outlet.
